/* screens/academy/landing/editorLogic.js — чистая логика конструктора лендинга.
   Вынесена из LandingEditor.jsx намеренно: на ней держатся AD-16 (порядок блоков,
   дубликат) и AD-14/AD-17 (ключи полей формы, SEO-поля), и её обязан проверять
   тест, не поднимая React и оболочку приложения. Никаких импортов из UI. */

/* AD-14: ключ доп. поля формы. НЕ выводим из подписи: подпись русская, а
   транслитерация «на лету» в JS уже подводила (`\w` не ловит кириллицу) — ключ
   поехал бы на каждой правке названия, а по ключу лежит значение в лиде. Поэтому
   ключ выдаём один раз, случайным, и больше не меняем. */
export function genFieldKey() {
  const rnd = Math.random().toString(36).slice(2, 8);
  return `f_${Date.now().toString(36).slice(-4)}${rnd}`;
}

/* AD-16: глубокая копия блока для «Дублировать». JSON-round-trip — блок и есть
   JSON (бэк хранит его в JSONField), а поверхностная копия оставила бы items[]
   ОБЩИМ массивом: два блока редактировались бы вместе, и выглядело бы это
   рабочим — худший вид дефекта. */
export function deepCopyBlock(block) {
  try {
    return JSON.parse(JSON.stringify(block));
  } catch {
    return { ...block };
  }
}

/* AD-16: перенос элемента списка на позицию (вырезать → вставить). Именно так, а
   не обменом местами: при перетаскивании через несколько карточек swap уронил бы
   порядок остальных. Возвращает ИСХОДНЫЙ массив, если двигать нечего — вызывающий
   по этому признаку не трогает state. */
export function moveInList(list, from, to) {
  const src = Array.isArray(list) ? list : [];
  if (from == null || to == null || from === to) return src;
  if (from < 0 || from >= src.length || to < 0 || to >= src.length) return src;
  const next = src.slice();
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next;
}

/* AD-17: SEO-поля приезжают ОТДЕЛЬНЫМ ключом карточки курса (`landing_meta`) —
   публичная форма `landing` осталась {enabled, blocks}. Приводим к трём строкам:
   нестроковое значение не должно уехать в PATCH, бэк отверг бы весь лендинг. */
export function normMeta(src) {
  const m = (src && typeof src === 'object') ? src : {};
  return {
    title: typeof m.title === 'string' ? m.title : '',
    description: typeof m.description === 'string' ? m.description : '',
    og_image: typeof m.og_image === 'string' ? m.og_image : '',
  };
}
